export const Card = ({ children, className }) => (
    <div className={`bg-white shadow p-4 rounded ${className || ''}`}>{children}</div>
  );
  
  export const CardContent = ({ children, className }) => (
    <div className={`mt-2 ${className || ''}`}>{children}</div>
  );

  export const CardHeader = ({ children, className }) => (
    <div className={`border-b pb-2 mb-2 ${className || ''}`}>{children}</div>
  );

  export const CardTitle = ({ children, className }) => (
    <h3 className={`text-lg font-bold ${className || ''}`}>{children}</h3>
  );
